import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Alert,
} from '@mui/material';
import { StarRating } from './StarRating';
import { RATING } from '../utils/constants';
import { Popup } from './Popup';

export const ReviewForm = () => {
  const LOADING_TEXT = 'Please wait while we prepare your review...';
  const [open, setOpen] = useState(false);
  const [dialogText, setDialogText] = useState('');
  const isLoading = dialogText === LOADING_TEXT;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [formData, setFormData] = useState({
    consultationSatisfaction: 4,
    comfortPreparedness: 4,
    professionalismCare: 4,
    painDiscomfort: 4,
    communication: 4,
    satisfactionResults: 4,
    recommendationLikelihood: 4,
    additionalComments: '',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: parseInt(value),
    }));
  };
  const handleTextBoxChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const generatePrompt = (formData) => {
    return `Write a review using not more than 100 words, in british english without using numbers for me, based on my following experience as a patient of Dr Francesca Vella in a non-invasive aesthetic procedure:
    - Consultation Satisfaction: ${formData.consultationSatisfaction}/5
    - Comfort and Preparedness: ${formData.comfortPreparedness}/5
    - Professionalism and Care: ${formData.professionalismCare}/5
    - Pain and Discomfort: ${formData.painDiscomfort}/5
    - Communication: ${formData.communication}/5
    - Satisfaction with Results: ${formData.satisfactionResults}/5
    - Recommendation Likelihood: ${formData.recommendationLikelihood}/5
    - Additional Comments: ${formData.additionalComments}
    Note that 1 is '${RATING[0]}', 2 is '${RATING[1]}', 3 is '${RATING[2]}', 4 is '${RATING[3]}', and ${RATING[4]} 'Excellent'
    `;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const prompt = generatePrompt(formData);
    setDialogText(LOADING_TEXT);
    handleClickOpen();
    const response = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer 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`,
      },
      body: JSON.stringify({
        model: 'gpt-4',
        messages: [{ role: 'user', content: prompt }],
        temperature: 0.7,
        max_tokens: 200,
        top_p: 1,
        frequency_penalty: 0,
        presence_penalty: 0,
      }),
    });
    const data = await response.json();
    setDialogText(data.choices[0].message.content);
  };

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', p: 0 }}>
      <Typography variant="h5" gutterBottom>
        Review Form
      </Typography>
      <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
        We've made sharing your experience simple with our quick review form.
      </Typography>
      <Alert
        severity={'info'}
        variant="standard"
        sx={{ mb: 2, textAlign: 'left' }}
      >
        Kindly rate your satisfaction on a scale from <strong>1</strong> to{' '}
        <strong>5</strong>.
      </Alert>
      <Box component="form" onSubmit={handleSubmit}>
        <StarRating formData={formData} handleChange={handleChange} />
        <TextField
          fullWidth
          label="Additional Comments"
          name="additionalComments"
          value={formData.additionalComments}
          onChange={handleTextBoxChange}
          multiline
          rows={4}
          margin="normal"
          variant="outlined"
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          sx={{ mb: 30 }}
        >
          Submit
        </Button>
      </Box>
      <Popup
        isLoading={isLoading}
        dialogText={dialogText}
        setDialogText={setDialogText}
        handleClose={handleClose}
        open={open}
      />
    </Container>
  );
};
